import React from 'react';
import { Link } from 'gatsby';

const IncidentCard = ({ incident }) => {
  const { impact } = incident;

  // Return correct classNames depending on impact

  let bodyClass = 'incidentBody ';
  let titleClass = 'incidentTitle ';
  switch (impact) {
    case 'clear':
      bodyClass += 'noIncidentsBody';
      titleClass += 'noIncidentsTitle';
      break;
    case 'minor':
      bodyClass += 'minorBody';
      titleClass += 'minorTitle';
      break;
    case 'major':
      bodyClass += 'majorBody';
      titleClass += 'majorTitle';
      break;
    case 'critical':
      bodyClass += 'criticalBody';
      titleClass += 'criticalTitle';
      break;
    default:
      bodyClass += 'noneBody';
      titleClass += 'noneTitle';
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      dateStyle: 'long',
      timeStyle: 'short',
    });
  };

  const capitalize = (str) => {
    if (str?.length > 1) {
      const startChar = str[0].toUpperCase();
      return startChar + str.substring(1, str.length);
    }
    return str?.toUpperCase();
  };

  return (
    <div className="col-12 incidentWrapper">
      <div className="incidentBox">
        <div className={titleClass}>{incident.name}</div>
        <div className={bodyClass}>
          {incident.updates.length > 0 && (
            <div className="incidentUpdateTitle">Incident updates</div>
          )}
          {incident.updates.map((update, i) => (
            <div className="incidentUpdate" key={i}>
              {update.body}
              <div className="incidentUpdateDate">
                {formatDate(update.created)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IncidentCard;
